import { createAsyncStateHook } from './utils'
import { getAuthor, getAuthorIndex } from 'src/services/authorServices'

export const useAuthor = createAsyncStateHook('author', getAuthor)

export const useAuthorIndex = createAsyncStateHook(
  'authorIndex',
  getAuthorIndex
)
